<template>
  
  <div class="content">
		<div class="content-c">
			<!-- <img class="load-img" src="../assets/images/loading.gif" mode="" /> 
			<div class="load-text color-9">{{$t('msgLoading')}}</div> -->
		</div>
	</div>
</template>

<script>
import { showLoading, hideLoading } from '../utils/loading'
import { apiBaseUrl } from '@/config/env.js'
import { isSafeRedirect } from '@/utils/index.js'
	
export default {
    data() {
        return {
            code: '',
			type: '',
			state: '',
			idToken: ''
        }
    },
	mounted() {
		this.idToken = this.getUrlParam('id-token')
		
		this.type = this.$route.query['type']
		
		if(this.type == 'daxiang'){
			showLoading();
			this.login()
		}
	},
    created() {
		
		// this.$router.push({
		// 	// path: window.localStorage.getItem('preUrl') || '/',
		// 	path: '/detail/1'
		// })
		/* this.idToken = this.getUrlParam('id-token')
		
		this.type = this.$route.query['type']
		
		if(this.type=='daxiang'){
			this.login()
		} */
    },
    methods: {
		getUrlParam(paraName) {
			let url = window.location.toString();
			let arrObj = url.split('?');
			
			if (arrObj.length > 1) {
				let arrPara = arrObj[1].split('&');
				let arr;
				for (let i = 0; i < arrPara.length; i++) {
					arr = arrPara[i].split('=');
					if (arr != null && arr[0] == paraName) {
						if (arr[1].indexOf('#')) {
							let str;
							str = arr[1].split('#');
							return str[0];
						}
						return arr[1];
					}
				}
				return '';
			} else {
				return '';
			}
		},
		recordInviteVisit() {
			const code = this.$storage.get('invitecode');
			if (!code) return Promise.resolve();
			return this.$api.recordInviteActivityVisit({
				code,
				visited_page: `${apiBaseUrl}web/`
			}).then(() => {
				this.$storage.remove('invitecode');
			});
		},
        login() {
			let _this = this;
			let data = {
				scope: 1,
				idToken: this.idToken,
				invitecode: this.$storage.get('invitecode') || ''
			};
			this.$api.getDaxiang(data).then(res => {
				if (res.status) {
					//console.log(res);return;
					if (res.data.token) {
						_this.$storage.set('userToken', res.data.token);
						// this.redirectHandler();
						
						_this.recordInviteVisit().then(() => {
						_this.$api.userInfo().then(result => {
							hideLoading();
						  if (result.status) {
						    _this.$storage.set("userInfo", result.data);
						    _this.userInfo = result.data;

							if(res.data.meituan_pc_login){//判断是否需要美团登录
								//跳转
								if (isSafeRedirect(res.data.meituan_pc_login)) {
									window.location.href = res.data.meituan_pc_login;//跳转美团
								}
							}else{
								
								let url = _this.$storage.get('redirectPage');
								 _this.$storage.remove('redirectPage');//登录后删除
								 if(url){
									if (isSafeRedirect(url)) {
										window.location.href = url;
									}
								 }else{
									window.location.href = '/web';
								 }
								
								/* _this.$router.push({
									path:  '/'//window.localStorage.getItem('preUrl') ||
								}) */
							}
						  }
						}); 
						});
						
					} else if (res.data.user_wx_id) {
						// _this.$common.redirectTo("/pagemember/setting/user_info/mobilebind?user_wx_id=" + res.data.user_wx_id)
					}
				} else {
					hideLoading();
					this.$message({
						message: res.msg,
						type: 'error'
					});
					// this.$common.errorToShow(res.msg, () => {
					// 	// 绑定手机号
					// 	if (res.data === '11027') {
					// 		this.$db.set('userToken', res.token);
					// 		// _this.$common.redirectTo("/pagemember/setting/user_info/mobilebind")
					// 	}
					// });
				}
			});
		}
    }
}
</script>

<style lang="scss" scoped>
.content {
    height: 90vh;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>